import React from 'react';
import './FloatingLabel.css';

const FloatLabelTextarea = ({ label, value, onChange, ...props }) => {
  return (
    <div className="float-label-textarea">
      <textarea
        value={value}
        onChange={onChange}
        required
        {...props}
      />
      <label>{label}</label>
    </div>
  );
};

export default FloatLabelTextarea;